import { addFieldPanel as addFieldPanelDef } from '@wix/wix-data-client-common/dist/esm/panels/panelDefs'
import getPanelDimensions from './getPanelDimensions'
import getPanelUrl from '@wix/wix-data-client-common/dist/esm/panels/getPanelUrl'

export default async ({
  hostname,
  editorSdkProxy,
  i18n,
  fieldTypes,
  selectedFieldType,
  collections,
  fields,
  collectionName,
  origin = 'DS_ADD_FIELD_BUTTON',
}) => {
  const isDeveloperModeEnabled =
    await editorSdkProxy.editor.developerMode.isEnabled()
  const { width, height } = getPanelDimensions({ isDeveloperModeEnabled })
  return editorSdkProxy.editor.openToolPanel({
    title: i18n.t('Editor_Add_Field_Panel_Title'),
    url: await getPanelUrl({
      hostname,
      relativeUrl: addFieldPanelDef.url,
      editorSdkProxy,
    }),
    initialData: {
      fieldTypes,
      selectedFieldType,
      collectionName,
      fields,
      collections,
      origin,
    },
    width,
    height,
    noPanelPadding: true,
  })
}
